export default "https://assets-v2.scaler.com/packs/files/loudspeaker-IN-US.4977f3.lottie";